import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        APP_COMPONENTS.progressComponents.update(data.id, data.perc);
    }
};
